// premiumFeatures.ts
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Adjust import as needed
import InsightsIcon from '@mui/icons-material/Insights'; // Adjust import as needed
import StarIcon from '@mui/icons-material/Star'; // Adjust import as needed
import { FormattedMessage } from 'react-intl';

export const premiumFeatures = [
  {
    label: <FormattedMessage id="home.premium.feature.advancedAI" />,
    description: <FormattedMessage id="home.premium.feature.advancedAI.description" />,
    icon: <InfoOutlinedIcon color="success" />
  },
  {
    label: <FormattedMessage id="home.premium.feature.customTone" />,
    description: <FormattedMessage id="home.premium.feature.customTone.description" />,
    icon: <StarIcon color="warning" />
  },
  {
    label: <FormattedMessage id="home.premium.feature.detailedAnalytics" />,
    description: <FormattedMessage id="home.premium.feature.detailedAnalytics.description" />,
    icon: <InsightsIcon color="primary" />
  }
];
